<template>
  <b-container v-if="order" class="p-0 order-status-page">
    <b-row>
        <b-col class="text-center mt-4 mb-4">
          <h1 class="pos-secondary-color">{{ $t('order_status_number', order) }}</h1>
        </b-col>
    </b-row>
    <b-row v-if="order && (env != 'local' && order.id > 179761 || env == 'local') && !order.is_refunded && !order.is_cancelled && (order.payment_status=='paid' || order.payment_status=='test_order_paid') && !containsUnassignedTicketes" class="mt-2 mb-5">
      <b-col class="text-center">
        <b-row v-if="ticketsBeingCreated" class="ticket-generation-loading">
          <b-col>
            <b-col class="text-center">
              <b-spinner ></b-spinner>
            </b-col>
            <b-col class="text-center small-btn-text">{{ $t('order_status_ticket_generating') }}</b-col>  
          </b-col>
        </b-row>
        <b-row v-else-if="!order.merged_tickets_url && ticketMergeBeingDone && !containsUnassignedTicketes" class="ticket-generation-loading">
          <b-col>
            <b-col class="text-center">
              <b-spinner ></b-spinner>
            </b-col>
            <b-col class="text-center small-btn-text">{{ $t('order_status_ticket_merging') }}</b-col>  
          </b-col>
        </b-row>
        <b-btn v-else-if="order.merged_tickets_url" class="btn-download-all-tickets border-radius-6"  :href="order.merged_tickets_url"  target="_blank">
          <b-icon class="download-icon" icon="download"/> {{ $t('download_tickets') }}
        </b-btn>
      </b-col>
    </b-row>
    <b-row class="border-radius-6 tickets-wrapper">
      <b-col>
        <div class="content-block-rounded content-header">
          <b-row>
            <b-col><h3 class="event-name font-weight-bold">{{ order.event.name }}</h3></b-col>
          </b-row>
          <b-row v-if="!order.event.continuous">
            <b-col><p class="event-full-date font-weight-bold mb-0">{{ order.event.starts_at }} - {{ order.event.ends_at }}</p></b-col>
          </b-row>

          <b-alert v-if="order.is_refunded" class="text-center alert alert-refunded" variant="primary" show>{{ $t('order_status_alert_refunded') }}</b-alert>
          <b-alert v-if="order.is_cancelled" class="text-center alert alert-cancelled" variant="danger" show>{{ $t('order_status_alert_cancelled') }}</b-alert>
          <b-alert v-if="order.payment_status === 'pending'" class="text-center alert alert-pending" variant="danger" show>{{ $t('order_status_alert_pending') }}</b-alert>
          <b-alert v-else-if="order.payment_status !== 'paid' && order.payment_status !== 'test_order_paid'" class="text-center alert alert-not-paid" variant="danger" show>{{ $t('order_status_alert_not_paid') }}</b-alert>
        </div>

        <div v-if="tickets">
          <div v-for="(ticket, index) in tickets" :key="index" class="content-block-rounded ticket-row-wrapper">
            <b-row :key="index" class="ticket-row align-items-center">
              <b-col :class="'col-9 ' + ((ticket.order_product.refunded_at) ? 'refunded' : '') + ' ' + ((ticket.status === 'cancelled') ? 'cancelled' : '')">
                <b-row>
                  <b-col class="product-name">
                    {{ ticket.order_product.product.product_group.name !== 'event_default_group' ? ticket.order_product.product.product_group.name + ' - ' : '' }} 
                    {{ ticket.order_product.product.name }} 
                    <span class="product-counter font-weight-normal ml-3">({{ index+1 }}/{{ tickets.length }})</span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="6" class="customer-name" v-if="ticket.customer">
                    {{ ticket.customer.first_name }} {{ ticket.customer.last_name }}
                  </b-col>
                  <b-col md="6" class="customer-name" v-else>
                    {{ $t('order_status_ticket_not_assigned') }}
                  </b-col>
                </b-row>
              </b-col>

              <b-col class="col-3 text-center text-md-right">

                <!-- Refunded -->
                <p v-if="ticket.order_product.refunded_at" class="refunded-text mt-2 mt-md-0 mb-0 d-flex align-items-center justify-content-center justify-content-md-end" style="height:100%">
                  {{ $t('order_status_product_refunded', ticket.order_product) }}
                </p> 

                <!-- Cancel -->
                <p v-else-if="ticket.status === 'cancelled'" class="cancelled-text mt-2 mt-md-0 mb-0 d-flex align-items-center justify-content-center justify-content-md-end" style="height:100%">
                  {{ $t('order_status_product_cancelled') }}
                </p> 

                <!-- Customer not assigned -->
                <div v-else-if="!ticket.customer" class="btn-assign-ticket d-inline-block text-center mt-2 mt-md-0 mb-0">
                    <a :href="ticket.link" target="_blank" class="download-ticket d-inline-block">
                      <span class="d-block mb-2">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="21" height="21" viewBox="0 0 21 21"><image id="Image_12" data-name="Image 12" width="21" height="21" xlink:href="data:image/png;base64,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"/></svg>
                      </span>
                      {{ $t('order_status_put_on_name') }}
                    </a>
                </div>

                <!-- Ticket is invited but not claimed -->
                <p v-else-if="!ticket.claimed_at && ticket.invited_at" class="invited-text mt-2 mt-md-0 mb-0 d-flex align-items-center justify-content-center justify-content-md-end" style="height:100%">
                  {{ $t('order_status_product_invited_at', ticket) }}
                </p>

                <!-- Ticket is generating -->
                <b-row v-else-if="!ticket.url" class="ticket-generation-loading">
                  <b-col>
                    <b-col class="text-center">
                      <b-spinner ></b-spinner>
                    </b-col>
                    <b-col class="text-center small-btn-text">{{ $t('order_status_ticket_generating') }}</b-col>  
                  </b-col>
                </b-row>
                
                <!-- Ticket exists -->
                <div v-else-if="ticket.url" class="d-inline-block text-center mt-2 mt-md-0 mb-0">
                  <a :href="ticket.url"  target="_blank" class="download-ticket d-inline-block">
                    <span class="d-block">
                      <svg xmlns="http://www.w3.org/2000/svg" height="23px" viewBox="0 -960 960 960" width="23px" fill="#000000" class="download-ticket-icon"><path d="M280-280h400v-80H280v80Zm200-120 160-160-56-56-64 62v-166h-80v166l-64-62-56 56 160 160Zm0 320q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z"/></svg>
                    </span>
                    {{ $t('download') }}
                  </a>
                </div>

              </b-col>

            </b-row>
          </div>
        </div>

      </b-col>
    </b-row>
  </b-container>
  <b-container v-else>
    <b-row>
      <b-col class="text-center content-block">
        <h1>{{ $t('order_loading') }}</h1>
        <b-spinner style="width: 10em; height: 10em;"></b-spinner>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import api from '../api'
import moment from 'moment'
import {mapActions, mapState} from 'vuex'
import {getEnvironment} from "@/functions";

export default {
  components: {},
  data() {
    return {
      order: null,
      tickets: [],
      copied: false,
      reminderTicket: null,
      ticketsBeingCreated: false,
      containsUnassignedTicketes: false,
      ticketMergeBeingDone: false,
      env: getEnvironment()
    }
  },
  methods: {
    getTickets(){
      api.order().getTickets(this.$route.params.id, this.$route.params.secret).then((tickets) => {
        this.ticketsBeingCreated = false
        this.tickets = tickets.map((ticket) => {

          if(ticket.order_product.refunded_at){
            ticket.order_product.refunded_at = moment(ticket.order_product.refunded_at).format('DD-MM-YYYY HH:mm');
          }
          if(ticket.invited_at){
            ticket.invited_at = moment(ticket.invited_at).format('DD-MM-YYYY HH:mm');
          }

          ticket.link = location.protocol + '//' + location.host + '/ticket/' + ticket.id + '/' + ticket.secret + '/claim'
          ticket.change_link = location.protocol + '//' + location.host + '/ticket/' + ticket.id + '/' + ticket.secret + '/claim?change=1'

          if (!ticket.customer || !ticket.customer.email) {
            this.containsUnassignedTicketes = true;
            return ticket
          }
          let email = ticket.customer.email;
          let middle = email.substr(3, email.length - 8)
          ticket.customer.email = email.replace(middle, '*******')

          // Check to see if we have a ticket that is being generated, so that we have to re-call the getTicket function again
          if( !ticket.order_product.refunded_at && ticket.status === 'active' && !ticket.url){
            this.ticketsBeingCreated = true
          }

          return ticket
        })

        if(this.ticketsBeingCreated){
          setTimeout(() => {
            this.getTickets()
          }, 3000)
        }
      })
      
    },
    getOrder(){
       api.order().getBySecret(this.$route.params.id, this.$route.params.secret).then((order) => {
        this.ticketMergeBeingDone = false
        order.event.starts_at = moment(order.event.starts_at).format('DD-MM-YYYY HH:mm');
        order.event.ends_at = moment(order.event.ends_at).format('DD-MM-YYYY HH:mm');
        this.order = Object.assign(order, {is_refunded: order.order_products.filter(p => p.refunded_at === null).length === 0})

        if(!order.merged_tickets_url){
          this.ticketMergeBeingDone = true
          setTimeout(() => {
            this.getOrder()
          }, 3000)
        }
      })
    },
    ...mapActions(['loadCompany'])
  },
  computed: {
    ...mapState(['company'])
  },
  created() {
    document.title = this.$t('order_status_title')
    if(!localStorage.getItem('ft_lang')) {
      api.pos().getByOrderIdAndSecret(this.$route.params.id, this.$route.params.secret).then(pos => {
        if (pos) {
          if(pos.language){
            this.$store.commit('setLanguage', pos.language)
          }
        }
      })
    }
    api.order().getBySecret(this.$route.params.id, this.$route.params.secret).then((order) => {
      order.event.starts_at = moment(order.event.starts_at).format('DD-MM-YYYY HH:mm');
      order.event.ends_at = moment(order.event.ends_at).format('DD-MM-YYYY HH:mm');
      this.order = Object.assign(order, {is_refunded: order.order_products.filter(p => p.refunded_at === null).length === 0})
    })
    this.getOrder()
    this.getTickets()
    this.loadCompany()
  }
}
</script>
<style scoped>
  .order-status-page{
    width:60%
  }
  .content-block-rounded{
    background-color:#FFF;
    padding:28px 35px;
  }
  .content-block-rounded.content-header{
    border-radius: 6px 6px 0 0 !important;
  }
  .content-block-rounded:last-child{
    border-radius: 0 0 6px 6px !important;
  }
  .ticket-row-wrapper {
    margin-top: 1px;
    padding: 20px 35px!important;
  }
  .content-block-rounded p, .content-block-rounded h1, .content-block-rounded h2, .content-block-rounded h3,
  .content-block-rounded span, .content-block-rounded div, .ticket-row p, .btn-assign-ticket a{
    color:#000
  } 
  p.event-full-date, p.invited-text{
    color:#000 !important
  }
  .btn-download-ticket{
    color:#FFF;
    padding:6px 35px
  }
  .btn-download-all-tickets{
    color:#FFF;
    padding:15px 25px;
    font-size:22px;
    font-weight: bold;
    margin:auto
  }
  .download-icon {
    margin-right: 14px;
  }
  span.product-counter{
    color:grey;
    font-size:14px
  }
  .refunded .product-name, .refunded .customer-name, .refunded span.product-counter, .cancelled .product-name, .cancelled .customer-name, .cancelled span.product-counter{
    color:lightgrey;
    text-decoration: line-through;
  }
  p.invited-text,.product-name{
    font-size:14px
  }
  p.refunded-text, p.cancelled-text{
    color:lightgrey !important;
    font-size:10px
  }
  .customer-name{
    font-size:10px
  }
  .small-btn-text{
    font-size:12px
  }
  .content-block-rounded div .alert{
    color:#FFF;
    font-size:16px
  }
  .alert-refunded, .alert-pending{
    background-color:#F0B52D
  }
  .alert-cancelled, .alert-not-paid{
    background-color:#F56C6C
  }
  h1 {
    font-size: 32px !important;
    font-weight: bold;
  }
  .tickets-wrapper {
    margin-top: 118px;
  }
  .btn-download-ticket, .btn-download-all-tickets {
    border-radius: 6px !important;
  }
  .download-ticket {
    color: #000000;
    font-size: 9px;
  }
  h3.event-name {
    font-size: 26px;
    margin-bottom:7px
  }
  p.event-full-date {
    font-size: 14px;
  }
  @media screen and (max-width: 768px) {
     .content-block-rounded{
      background-color:#FFF;
      padding:17px;
    }
    .ticket-row-wrapper {
      padding: 15px 17px!important;
    }
    .order-status-page{
      width:unset
    }
    h1{
      font-size:22px!important
    }
    h3,h3.event-name,.product-name{
      font-size:16px!important
    }
    .event-full-date,.alert,.customer-name,p.refunded-text, p.invited-text{
      font-size:12px!important
    }
    .alert{
      margin-bottom:0
    }
    .btn-download-ticket{
      padding:5px 15px
    }
    .download-icon{
      width:17px;
      height:17px;
      margin-right:5px
    }
    .btn-download-all-tickets{
      padding:10px 15px;
      font-size:18px;
    }
    p.refunded-text, p.cancelled-text,span.product-counter{
      font-size:13px
    }
    .product-name, .product-counter{
      font-size:16px
    }
  }
  @media screen and (max-width: 400px) {
    .btn-download-ticket{
      padding:5px 10px;
      font-size:14px
    }
    .btn-download-all-tickets{
      padding:11px 25px;
      font-size:15pt;
    }
  }

</style>
